var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragAndDropIconSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.5C3 8.32843 2.32843 9 1.5 9C0.671573 9 0 8.32843 0 7.5C0 6.67157 0.671573 6 1.5 6C2.32843 6 3 6.67157 3 7.5Z",
    fill: "#CFCFCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.5C9 8.32843 8.32843 9 7.5 9C6.67157 9 6 8.32843 6 7.5C6 6.67157 6.67157 6 7.5 6C8.32843 6 9 6.67157 9 7.5Z",
    fill: "#CFCFCF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1.5C3 2.32843 2.32843 3 1.5 3C0.671574 3 7.15256e-07 2.32843 7.15256e-07 1.5C7.15256e-07 0.671573 0.671574 0 1.5 0C2.32843 0 3 0.671573 3 1.5Z",
    fill: "#CFCFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C9 2.32843 8.32843 3 7.5 3C6.67157 3 6 2.32843 6 1.5C6 0.671573 6.67157 0 7.5 0C8.32843 0 9 0.671573 9 1.5Z",
    fill: "#CFCFCF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5C3 14.3284 2.32843 15 1.5 15C0.671574 15 7.15256e-07 14.3284 7.15256e-07 13.5C7.15256e-07 12.6716 0.671574 12 1.5 12C2.32843 12 3 12.6716 3 13.5Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5C9 14.3284 8.32843 15 7.5 15C6.67157 15 6 14.3284 6 13.5C6 12.6716 6.67157 12 7.5 12C8.32843 12 9 12.6716 9 13.5Z",
    fill: "#CFCFCF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDropIconSmall);
export default __webpack_public_path__ + "static/media/drag-and-drop-icon-small.c8a2d53372524b7d1c6a57ac1e74a73c.svg";
export { ForwardRef as ReactComponent };